import { tipCalloutStyles } from './tinyContentStyles'
import { tinyMCESetup, imageUploadHandler, tinyFilePicker, returnUrlAsRecieved, mediaURLResolver } from './helpers'

export const apiKey = "nozb66xx8bd4ng55xzewb7obn09fln14zbh0rjyi4ip3rbf7"

export const tinyMCEInit = {
  setup: tinyMCESetup,
  menubar: false,
  statusbar: false,
  resize: false,
  relative_urls : false,
  remove_script_host : false,
  image_description: false,
  convert_urls : true,
  contextmenu: 'link',
  urlconverter_callback: returnUrlAsRecieved,
  default_link_target: '_blank',
  file_picker_types: 'image',
  browser_spellcheck: true,
  images_upload_handler: imageUploadHandler,
  file_picker_callback: tinyFilePicker,
  block_formats: 'Normal Text=p;Header 2=h2;Header 3=h3',
  paste_data_images: true,
  plugins: [
    'image', 'autolink', 'visualblocks', 'textcolor',
    'lists', 'contextmenu', 'textcolor', 'autolink', 'link', 'code',
    'codesample', 'paste', 'fullscreen', 'media', 'nonbreaking'
  ],
  nonbreaking_force_tab: true,
  image_dimensions: false,
  media_dimensions: false,
  media_poster: false,
  media_alt_source: false,
  object_resizing : false,
  toolbar: 'undo redo | formatselect | bold italic underline | link image media | numlist bullist | codesample | callouts',
  branding: false,
  height: window.innerHeight * 0.75,
  insert_toolbar: 'quickimage quicktable',
  content_style: tipCalloutStyles,
  media_url_resolver: mediaURLResolver,
  content_css: [
    'https://fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
    'https://s3.amazonaws.com/tide-assets/proxima-nova-regular.otf',
    'https://s3.amazonaws.com/tide-assets/proxima-soft-semibold.eot',
    'https://www.tinymce.com/css/codepen.min.css'
  ],
  target_list: [
    { title: 'New Tab', value: '_blank' },
    { title: 'Same Tab', value: '_self' }
  ],
  extended_valid_elements: "a[href|target=_blank|target=_self]",
  link_assume_external_targets: true
}